/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-10 15:26:33
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-04-10 15:26:33
 */

import ServiceNumber from './ServiceNumber';

export default ServiceNumber;
